import { useIntl } from 'react-intl';
import { SnowSettingsPanel } from 'components';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { MouseEvent, useEffect, useState } from 'react';
import { IconButton, Popover, Tooltip } from '@mui/material';
import { isNewYearSnowDayTR } from 'components/new-year-snow-overlay';

const SnowSettingsButton = () => {
  // other hooks
  const intl = useIntl();

  // useState hooks
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [showSnow, setShowSnow] = useState(() => isNewYearSnowDayTR());

  // dynamic variables
  const open = Boolean(anchorEl);

  // sync helper functions
  const handleOpen = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // useEffect hooks
  useEffect(() => {
    const id = window.setInterval(() => setShowSnow(isNewYearSnowDayTR()), 60_000);

    return () => window.clearInterval(id);
  }, []);

  if (!showSnow) return null;

  return (
    <>
      <Tooltip title={intl.formatMessage({ id: 'snow.tooltip.settings', defaultMessage: 'Kar ayarları' })}>
        <IconButton onClick={handleOpen} size="small" aria-label="snow-settings">
          <AcUnitIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { borderRadius: 2 } }}>
        <SnowSettingsPanel />
      </Popover>
    </>
  );
};

export default SnowSettingsButton;
